import React from "react";
import classes from "../../styles/Humidity.module.css";
import BaseBlock from "./BaseBlock";
import Preloader from "../services/Preloader";
import { useWeather } from "../../context/WeatherProvider";
import { useIsLoad } from "../../context/IsLoadProvider";

const Humidity = () => {
	const { weatherData } = useWeather();
	const { isLoad } = useIsLoad();

	return (
		<BaseBlock title="Precipitation">
			<div className={classes.humidity}>
				<div className={classes.humidity_air}>
					<div className={classes.humidity_icon}>
						<svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#000000">
							<g>
								<path
									d="M339.7 882.5C196.6 882.5 80.2 766.1 80.2 623c0-133.2 204.8-395.1 228.2-424.5 5.8-7.3 14.5-11.6 23.8-11.7 9.4-0.1 18.1 3.9 24.1 11 1.5 1.8 37.7 44.8 82.2 105.2 10.1 13.8 7.2 33.2-6.6 43.3-13.8 10.1-33.2 7.2-43.3-6.6-21.3-29-40.9-54-55.3-72.1-69.2 92-191.2 271.5-191.2 355.4 0 108.9 88.6 197.6 197.6 197.6S537.3 731.9 537.3 623c0-17.1 13.9-31 31-31s31 13.9 31 31c-0.1 143.1-116.5 259.5-259.6 259.5z"
									fill="#489ff0"></path>
								<path
									d="M363.7 468.8c-27.9 59.7-46.8 115.7-46.8 158.4 0 164.6 133.4 298 298 298s298-133.4 298-298c0-12.8-1.9-26.9-5.5-41.9-327.2 33.9-284.9-194.9-543.7-116.5z"
									fill="#1689f5"></path>
								<path
									d="M333.6 567.6c-38.2 239.9 123 357.7 287.3 357.7 92.8 0 144.9-12.1 199.6-78.6-261.5 20.7-428.7-99.2-486.9-279.1z"
									fill="#489ff0"></path>
								<path
									d="M614.9 956.1C433.5 956.1 286 808.5 286 627.2c0-173.4 283.4-532.4 295.5-547.6 5.8-7.3 14.5-11.6 23.8-11.7 9.3-0.1 18.1 3.9 24.1 11 2 2.3 49 58.2 106.8 136.6 10.1 13.8 7.2 33.2-6.6 43.3-13.8 10.1-33.2 7.2-43.3-6.6-31.8-43.2-60.6-79.8-79.9-103.7C517 266.1 347.9 512.3 347.9 627.2c0 147.2 119.8 267 267 267s267-119.8 267-267c0-29.7-13.2-87.9-76.4-196.2-8.6-14.8-3.6-33.7 11.2-42.3 14.8-8.6 33.7-3.6 42.3 11.2 57.1 97.9 84.8 172.2 84.8 227.4 0 181.3-147.6 328.8-328.9 328.8z"
									fill="#489ff0"></path>
							</g>
						</svg>
					</div>
					<div>
						<p className={classes.humidity_air__title}>Air humidity</p>
						{isLoad ? (
							<div className={classes.humidity_value}>
								{weatherData?.current?.humidity}
								<span>%</span>
							</div>
						) : (
							<Preloader width="70" />
						)}
					</div>
				</div>
				<div className={classes.precipitation}>
					<div className={classes.humidity_icon}>
						<svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#000000">
							<g>
								<path
									d="M747.2 359.1c-21.1 0-41.4 3.9-60.2 11.1-9.7-112.1-98.4-200-206.5-200-104.8 0-191.4 82.6-205.4 189.8-5.9-0.6-11.8-0.9-17.8-0.9-98.3 0-177.9 84.6-177.9 188.9s77.5 189.3 175.7 189.3c1.7 0 8.5-0.3 11.4-0.5h-1.3v-0.2c3.3 0 3.1 0.1 1.3 0.2l442.2 0.5c12.9 0 24.5-0.6 38.5-0.6 98.2 0 177.8-84.5 177.8-188.8s-79.6-188.8-177.8-188.8z"
									fill="#1689f5"></path>
								<path
									d="M108.3 458.9c-13.4 26.5-21 56.8-21 89 0 104.3 77.5 189.3 175.7 189.3 1.7 0 8.5-0.3 11.4-0.5h-1.3v-0.2c3.3 0 3.1 0.1 1.3 0.2l442.2 0.5c5.9 0 11.6-0.1 17.3-0.2l1.7-2.4c-366.3 0.1-563.1-40.3-627.3-275.7z"
									fill="#489ff0"></path>
								<path
									d="M333.9 876.6c-4 0-8.1-1.2-11.6-3.7-8.9-6.4-10.9-18.8-4.5-27.7l119-165.6c6.4-8.9 18.8-10.9 27.7-4.5 8.9 6.4 10.9 18.8 4.5 27.7L350 868.4c-3.8 5.3-9.9 8.2-16.1 8.2zM437.8 876.6c-4 0-8.1-1.2-11.6-3.7-8.9-6.4-10.9-18.8-4.5-27.7l119-165.6c6.4-8.9 18.8-10.9 27.7-4.5 8.9 6.4 10.9 18.8 4.5 27.7l-119 165.6c-3.8 5.3-9.9 8.2-16.1 8.2zM541.7 876.6c-4 0-8.1-1.2-11.6-3.7-8.9-6.4-10.9-18.8-4.5-27.7l119-165.6c6.4-8.9 18.8-10.9 27.7-4.5 8.9 6.4 10.9 18.8 4.5 27.7l-119 165.6c-3.8 5.3-9.9 8.2-16.1 8.2z"
									fill="#489ff0"></path>
								<path
									d="M718.5 757.5c-11.9 0-21.5-9.6-21.5-21.5s9.6-21.5 21.5-21.5c6.2 0 12-0.1 18-0.3 6.4-0.1 13.1-0.3 20.4-0.3 86.2 0 156.3-75.1 156.3-167.3S843.1 379.3 757 379.3c-18 0-35.7 3.3-52.5 9.7l-26.7 10.2-2.5-28.5c-8.9-102.8-88.4-180.3-185.1-180.3-92.2 0-171.3 73.5-184.1 171l-2.7 20.8-20.9-2.2c-5.2-0.6-10.4-0.8-15.6-0.8-86.2 0-156.3 75.1-156.3 167.3 0 88.3 63 160.9 142.7 167.3l21.5-0.2h2.7c0.8 0 1.7 0.1 2.5 0.2l39.5 0.1c11.9 0 21.5 9.7 21.5 21.6 0 11.9-9.7 21.5-21.5 21.5l-42.6-0.1c-1.1 0.1-2.5 0.1-4 0.2-3.3 0.1-6.9 0.3-8.1 0.3-53.4 0-103.3-22.2-140.5-62.5-36.6-39.6-56.7-92.3-56.7-148.4 0-115.9 89.3-210.3 199.2-210.4 23.1-109 116-188.8 223.4-188.8 57.7 0 112.8 22.7 155.2 64 35.6 34.7 59.7 80 69.2 129.6 13.9-3.2 28-4.8 42.3-4.8 109.9 0 199.3 94.4 199.3 210.4s-89.4 210.4-199.3 210.4c-6.9 0-13.3 0.1-19.5 0.3-6.2 0.2-12.4 0.3-18.9 0.3z"
									fill="#489ff0"></path>
							</g>
						</svg>
					</div>
					<div>
						<p className={classes.precipitation__title}>Precipitation</p>
						{isLoad ? (
							<div className={classes.precipitation__value}>
								{weatherData?.current?.precip_mm}
								<span>mm</span>
							</div>
						) : (
							<Preloader width="50" />
						)}
					</div>
				</div>
			</div>
		</BaseBlock>
	);
};

export default Humidity;
